// import { useNavigate } from "react-router-dom";
import { icons } from "utils/constants";
import { Button } from "components";
import "./TestMode.scss";
import { useSelector } from "react-redux";

const TestMode = () => {
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};
  // const navigate = useNavigate();
  return (
    <div id="testmode-container">
      <div>
        <div className="h-300 mb-4">
          <img src={isDarkMode ? icons.bannerDark : icons.banner} alt="banner" className="fit-image" />
        </div>
        <div className={`text-26-700 mb-2 text-center ${isDarkMode ? "color-ffff" : "color-2749"}`}>
          UNoDE is in private alpha. Invites will be sent out.
          {/* Thank You For Login */}
        </div>
        {/* <div className="f-center">
          <div className="text-16-400 color-7e91 text-center">
            We are happy to see you here, Currently we are in beta testing mode.{" "}
            <br />
            The amount of work has been immense. Alpha users are currently
            playing with the system and giving feedback. <br />
            We plan to continuously invite more private alpha users over the
            next few weeks
          </div>
        </div> */}

        <div className="f-center mt-4">
          <Button
            btnStyle="PD"
            btnText="Join waitlist"
            onClick={() => {
              window.open(
                "https://docs.google.com/forms/d/e/1FAIpQLSfSnNu6nKrEOEfJlCEYAEMhcPMgUMVDVjHOFKN8uMPbqW8rZQ/viewform",
                "_blank"
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TestMode;
